// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SfejN","placeholdersHeader":"styles_placeholdersHeader__D9-O0","editorStyle":"styles_editorStyle__21uSy","placeholdersBox":"styles_placeholdersBox__1axnZ"};